import { useUserStore } from '@/stores';
import { UserRole } from '@/types';

type RoleGuardProps = {
    children: React.ReactNode;
    roles: UserRole[];
};

export const RoleGuard = ({ children, roles }: RoleGuardProps) => {
    const { user } = useUserStore();

    if (!user || !user.role) {
        return null;
    }

    if (!roles.includes(user.role)) {
        return null;
    }

    return children;
};
